// import React from 'react';
// // import logo from './logo.svg';
// import './App.css';
// import LandingPage from './pages/LandingPage/LandingPage';

// function App() {
//   return (
//     <div className="App">
//        <LandingPage />
//     </div>
//   );
// }

// export default App;

// import './amplifyConfig';
import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { withAuthenticator } from "@aws-amplify/ui-react";
import AppRoutes from "Routes";

const App: React.FC = () => {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
};

export default App;

// export default withAuthenticator(App);
